import React from 'react';

export const ExecutiveTemplate = ({ data }) => {
  return (
    <div className="h-full min-h-[297mm] font-serif bg-[#fdfbf7] p-12 text-gray-900">
      <header className="border-b-2 border-gray-900 pb-8 mb-8 flex justify-between items-end">
        <div>
          <h1 className="text-4xl font-bold tracking-tight mb-2 uppercase">{data.personalInfo.firstName} <span className="text-gray-600">{data.personalInfo.lastName}</span></h1>
          <p className="text-lg italic text-gray-600">Professional Profile</p>
        </div>
        <div className="text-right text-sm leading-relaxed text-gray-600 font-sans">
          <p>{data.personalInfo.email}</p>
          <p>{data.personalInfo.phone}</p>
          <p>{data.personalInfo.linkedin}</p>
        </div>
      </header>

      {data.personalInfo.summary && (
        <section className="mb-8">
           <h2 className="text-sm font-bold uppercase tracking-widest border-b border-gray-300 mb-4 pb-1 font-sans text-gray-500">Executive Summary</h2>
           <p className="text-justify leading-relaxed text-gray-800">{data.personalInfo.summary}</p>
        </section>
      )}

      <div className="space-y-8">
        {data.sectionsOrder.map((sectionId) => {
            // Experience
            if (sectionId === 'experience' && data.experience.length > 0) {
                return (
                    <section key={sectionId}>
                        <h2 className="text-sm font-bold uppercase tracking-widest border-b border-gray-300 mb-6 pb-1 font-sans text-gray-500">Professional Experience</h2>
                        <div className="space-y-6">
                            {data.experience.map((exp) => (
                            <div key={exp.id}>
                                <div className="flex justify-between items-baseline mb-1">
                                    <h3 className="font-bold text-lg">{exp.role}</h3>
                                    <span className="font-sans text-xs text-gray-500 font-bold">{exp.startDate} – {exp.endDate}</span>
                                </div>
                                <p className="font-semibold text-gray-700 mb-2 italic">{exp.company}</p>
                                <p className="text-sm leading-relaxed text-gray-800 pb-4 border-b border-dotted border-gray-300 last:border-0 whitespace-pre-wrap">{exp.description}</p>
                            </div>
                            ))}
                        </div>
                    </section>
                );
            }

            // Education
            if (sectionId === 'education' && data.education.length > 0) {
                return (
                    <section key={sectionId}>
                        <h2 className="text-sm font-bold uppercase tracking-widest border-b border-gray-300 mb-4 pb-1 font-sans text-gray-500">Education</h2>
                        <div className="grid grid-cols-1 gap-4">
                            {data.education.map((edu) => (
                            <div key={edu.id} className="flex justify-between items-baseline">
                                <div>
                                    <h3 className="font-bold text-base">{edu.school}</h3>
                                    <p className="text-sm italic text-gray-700">{edu.degree}</p>
                                </div>
                                <span className="text-xs text-gray-500 font-sans font-bold">{edu.year}</span>
                            </div>
                            ))}
                        </div>
                    </section>
                );
            }

            // Skills
            if (sectionId === 'skills' && data.skills.length > 0) {
                return (
                     <section key={sectionId}>
                        <h2 className="text-sm font-bold uppercase tracking-widest border-b border-gray-300 mb-4 pb-1 font-sans text-gray-500">Key Competencies</h2>
                        <ul className="grid grid-cols-3 gap-2 text-sm text-gray-800">
                            {data.skills.map((skill, index) => (
                            <li key={index} className="flex items-center">
                                <span className="w-1.5 h-1.5 bg-gray-400 rounded-full mr-2"></span>
                                {skill}
                            </li>
                            ))}
                        </ul>
                    </section>
                );
            }

            // Custom Sections
            const customSection = data.customSections.find(s => s.id === sectionId);
            if (customSection && customSection.items.length > 0) {
                return (
                    <section key={sectionId}>
                         <h2 className="text-sm font-bold uppercase tracking-widest border-b border-gray-300 mb-6 pb-1 font-sans text-gray-500">{customSection.title}</h2>
                         <div className="space-y-4">
                            {customSection.items.map((item) => (
                             <div key={item.id}>
                                <h3 className="font-bold text-base">{item.name}</h3>
                                {item.link && <a href={`https://${item.link}`} target="_blank" rel="noreferrer" className="text-gray-500 italic text-sm hover:underline block mb-1">{item.link}</a>}
                                <p className="text-sm leading-relaxed text-gray-800 whitespace-pre-wrap">{item.description}</p>
                             </div>
                            ))}
                         </div>
                    </section>
                );
            }

            return null;
        })}
      </div>
    </div>
  );
};
